import React, {Component} from 'react'

// import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import {withRouter} from 'react-router-dom'

import {RCMenu, RCMenuUser} from '../menu'

import { Popover, Position } from "@blueprintjs/core";

class Main extends Component {
  render () {
    return (
      <div>
        <nav className="pt-navbar pt-dark">
          <div style={{margin: '0 auto'}}>
            <div className="pt-navbar-group pt-align-left">
              <div className="pt-navbar-heading">RConnect</div>
              <Popover content={<RCMenu />} position={Position.BOTTOM_LEFT}>
                  <button className="pt-button pt-minimal pt-icon-menu">Menu</button>
              </Popover>
            </div>
            <div className="pt-navbar-group pt-align-right">
              <Popover content={<RCMenuUser />} position={Position.BOTTOM_RIGHT}>
                  <button className="pt-button pt-minimal pt-icon-user"></button>
              </Popover>
            </div>
          </div>
        </nav>
        <div style={{padding: 10}}>
          {this.props.children}
        </div>
      </div>
    )
  }

  irPara (path) {
    this.props.history.push(path)
  }
}

/*function mapStateToProps (state) {
  let {dataObject, isOpen, isFetching, error} = state.cadAcesso

  return {
    dataObject,
    isOpen,
    isFetching,
    error
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({setPropDataObject, salvar, close}, dispatch)
}*/

export default withRouter(connect()(Main))


// WEBPACK FOOTER //
// ./src/scenes/main/Main.js